import type { ReactElement, ReactNode } from 'react';

export interface TableScrollProps {
  /** Announced to screen readers as the name of the scrollable region. */
  readonly label: string;
  readonly children: ReactNode;
}

/**
 * Horizontal scroll container for wide tables.
 *
 * The page body must never scroll sideways at 390px — the table does, inside
 * this box. `tabIndex={0}` makes the region reachable by keyboard, which is
 * required for a scrollable area to be operable without a pointer.
 */
export function TableScroll({ label, children }: TableScrollProps): ReactElement {
  return (
    <div className="scroll-x" role="region" aria-label={label} tabIndex={0}>
      {children}
    </div>
  );
}
